/**
 * Meio de impressão escolhido NESTE aparelho (Bluetooth, RawBT, navegador...): um só lugar para
 * a nota, o pedido de venda e a tela da impressora. Fica no próprio aparelho (cada celular tem a
 * sua impressora); nada vai ao servidor.
 */
import { availableTransports, type Transport } from "./drivers";

const PREF = "cafegestor.impressora";

/** O meio preferido, se ainda existir neste navegador; senão o primeiro disponível. */
export function preferredTransport(options: Transport[] = availableTransports()): Transport {
  try {
    const saved = localStorage.getItem(PREF) as Transport | null;
    if (saved && options.includes(saved)) return saved;
  } catch {
    /* sem armazenamento */
  }
  return options[0] ?? "navegador";
}

export function savePreferredTransport(t: Transport): void {
  try {
    localStorage.setItem(PREF, t);
  } catch {
    /* sem armazenamento: vale só agora */
  }
}
